import { createdBySystemNameMappings } from '../../constants'
import { epochToViewUTC } from '../../functions'
import { DataRecurringRule } from '../../types'
import { methods } from './expense.constants'
import { Rental } from '../rental'
import * as lodash from 'lodash'
import * as R from 'ramda'

export enum ExpenseApprovalStatus {
  Pending = 'pending',
  Denied = 'denied',
  Approved = 'approved',
  OnHold = 'hold',
}

export const expenseApprovalStatusOptions = [
  { label: $localize`Pending`, id: ExpenseApprovalStatus.Pending },
  { label: $localize`Denied`, id: ExpenseApprovalStatus.Denied },
  { label: $localize`Approved`, id: ExpenseApprovalStatus.Approved },
  { label: $localize`On Hold`, id: ExpenseApprovalStatus.OnHold },
]

export enum ExpensePaidStatus {
  Unpaid = 1,
  Paid = 2,
}

export interface ExpenseResponse extends DataRecurringRule {
  pkey: string
  rental_id: string
  inquiry_id: string
  payment_account: string
  date: number

  // @depreated
  photo: string
  attachments: string[]

  description: string
  category: string
  account: number
  archived: number
  due: number
  method: string
  created: number
  status: ExpensePaidStatus
  amount: number
  created_by: string
  trigger_id?: string
  approval_status?: ExpenseApprovalStatus

  events?: string // Automated Expense

  // recurrence sync result the API embeds when it pushes the expense to the
  // expense service (create/update with a recurrence rule)
  expenseApi?: { http_code: number; response?: unknown }
}
export interface ExpenseView extends ExpenseResponse {
  isAuto: boolean
  rental: Rental
  createdView: string
  dateView: string
  dueView: string
  methodView: string
  statusView: string

  createdByView: string

  rentalView: string
  amountCodeView: string
}

export type ExpenseRecurringFilter = 'all' | 'recurring' | 'not_recurring'

export interface IExpenseFilters {
  rentals: string[]
  method: string
  status: number | string
  categories: string[]
  recurring?: ExpenseRecurringFilter
  period: {
    from: number
    to: number
  }
}

export interface CreateExpensePayload {
  date: number
  due: number
  category: string
  amount: number
  status: number
  method: string

  inquiry_id?: string
  repeat?: number
  rental_id?: string
  description: string
  photo?: string
  attachments?: string[]
  approval_status?: ExpenseApprovalStatus
}

export type UpdateExpensePayload = Partial<CreateExpensePayload>

// Approval
export interface ExpenseApproverItem {
  user_id: string
  amount: number
  currency?: string
}

export interface ExpenseApprovalSettings {
  pkey: string
  account: number
  auto_approve_amount: number
  approvers: ExpenseApproverItem[]
}

export type UpdateExpenseSettingsPayload = Partial<Omit<ExpenseApprovalSettings, 'pkey' | 'account'>>

export interface FetchExpenseStatsReportParams {
  start?: number
  end?: number
  rentals?: string[]
  statuses?: number[]
  approval_statuses?: ExpenseApprovalStatus[]
  categories?: string[]
}

export interface ExpenseCategoryReportItem {
  category: string
  amount: number
  date: string
}

export function getExpenseStatus(status: ExpensePaidStatus): string {
  let statusText = '...'

  switch (status) {
    case 1:
      statusText = $localize`Unpaid`
      break
    case 2:
      statusText = $localize`Paid`
      break
    default:
      statusText = $localize`Unpaid`
  }

  return statusText
}

export function getExpenseMethod(expense: ExpenseResponse): string {
  return R.pipe(
    R.find((m: { name: string; value: string }) => m.value === R.prop('method', expense)),
    R.prop('name'),
    R.defaultTo($localize`Unknown`)
  )(methods)
}

export function toExpenseView(expense: ExpenseResponse): ExpenseView {
  return {
    ...expense,
    photo: expense.photo && (expense.photo + '').replace('http:', ''),
    isAuto: !!createdBySystemNameMappings[expense.created_by],
    createdView: epochToViewUTC(expense.created),
    dateView: epochToViewUTC(expense.date),
    dueView: epochToViewUTC(expense.due),
    methodView: lodash.capitalize(getExpenseMethod(expense)),
    statusView: getExpenseStatus(expense.status),
  } as ExpenseView
}
